import { AxiosResponse } from 'axios';
import { ROLE_API_ENDPOINTS } from '../constants/apiEndpoints';
import { Role } from '../types/interfaces/role.interfaces';
import { appContextGet } from './httpCommon/appAxios.service';
import { AccountRoles, AppRoles } from '../types/enums';

export const getRoles = (): Promise<AxiosResponse<Role<AppRoles | AccountRoles>[], any>> => {
  return appContextGet(ROLE_API_ENDPOINTS.ROLES);
};
